hmi.utils.insert_module({
  name: "pressure",
  instance: null,
  groupType: hmi.constant.groupType.component,
  type: hmi.constant.PRESSURE,
  pipe: true,
  svgName: "pressure"
});

hmi.utils.load_svg_symbol(
  "assets/images/hmiCommponents/pressure.svg",
  hmi.symbols,
  "pressure"
);

hmi.models.pressure = function () {
  "use strict";

  //============================================================
  // Public Variables with Default Settings
  //------------------------------------------------------------
  var showMode = hmi.constant.showMode.monitor,
    signal = hmi.constant.signals.analog,
    availableWidth,
    availableHeight,
    zoomTrans,
    connection_box = hmi.utils.connection_box().left(true).rigth(true),
    resize_component = hmi.utils
      .resize_component()
      .heightComponent(50)
      .widthComponent(50)
      .widthMaxComponent(500)
      .heightMaxComponent(500)
      .dragCallBack(resizeDragCallback),
    action_component = hmi.utils.action_execute(),
    connections = hmi.utils
      .connections()
      .conect_type(hmi.constant.conection_types.double)
      .position_connection(hmi.constant.pipeCPosition.B);

  //============================================================
  // Private Variables
  //------------------------------------------------------------

  var allData = [],
    type = hmi.constant.PRESSURE,
    groupType = hmi.constant.groupType.component,
    subComponent = {
      main: 0,
      alias: 1,
      value: 2
    },
    pipe,
    pendingPipe,
    selectTargetId,
    isInitialize = false,
    dragBehavior,
    dragAliasBehavior,
    dragValueBehavior,
    dragTarget,
    dragSubComponentTarget,
    dispatch = d3.dispatch("componentChange", "selectElement", "selectText"),
    svgNode,
    color = {
      normal: "#00a000",
      normalBorder: "#00f000",
      select: "#0000a0",
      warning: "#a0a000",
      warningBk: "#a0a000a0",
      warningBorder: "#f0f000",
      alarm: "#a00000",
      alarmBk: "#a00000a0",
      alarmBorder: "#f00000"
    },
    defaultWidth = 75,
    defaultHeight = 75,
    defaultAliasX = 0,
    defaultAliasY = -10,
    defaultValueX = 0,
    defaultValueY = 90,
    needleScales = [],
    normalScales = [],
    minAlarmScales = [],
    minWarningScales = [],
    maxWarningScales = [],
    maxAlarmScales = [],
    xScale = d3.scale.quantize(),
    yScale = d3.scale.quantize(),
    colorWarning = "#A0A000",
    colorError = "#A00000";

  var initialize = function () {
    isInitialize = true;

    //create behaviors
    dragBehavior = d3.behavior
      .drag()
      .on("dragstart", function (d, i) {
        d3.event.sourceEvent.stopPropagation();
        if (dragTarget && showMode === hmi.constant.showMode.design) {
          dragTarget.parentNode.appendChild(dragTarget);
          d3.select(dragTarget).attr("pointer-events", "none");
        }
      })
      .on("drag", function (d, i) {
        if (dragTarget && showMode === hmi.constant.showMode.design) {
          var eventX = d3.event.x - defaultWidth / 2;
          var eventY = d3.event.y - defaultHeight / 2;

          var component = null;
          var componentIndex = allData.findIndex(function (element) {
            return element.id === selectTargetId;
          });
          if (componentIndex !== -1) {
            component = allData[componentIndex];
            component.x = eventX;
            component.y = eventY;
            updateComponentPosition(component);
            transformComponentPosition(this, component);
          }
        }
      })
      .on("dragend", function (d, i) {
        if (dragTarget && showMode === hmi.constant.showMode.design) {
          var component = null;
          var componentIndex = allData.findIndex(function (element) {
            return element.id === selectTargetId;
          });
          if (componentIndex !== -1) {
            component = allData[componentIndex];
            component.x = xScale(component.x + defaultWidth / 2);
            component.y = yScale(component.y + defaultHeight / 2);
            updateComponentPosition(component);
            transformComponentPosition(this, component);
          }

          unSelectComponent();

          if (component) {
            dispatch.componentChange({
              component: component
            });

            var linkItem = {
              linkId: component.id,
              x: component.x,
              y: component.y,
              width: d.width,
              height: d.height,
              positionPipe: d.positionPipe
            };
            pipe.updateChangeLink(linkItem);
          }
        }
      });
    //alias
    dragAliasBehavior = d3.behavior
      .drag()
      .on("dragstart", function (d, i) {
        d3.event.sourceEvent.stopPropagation();
        if (
          dragSubComponentTarget &&
          showMode === hmi.constant.showMode.design
        ) {
          dragSubComponentTarget.attr("pointer-events", "none");
        }
      })
      .on("drag", function (d, i) {
        if (
          dragSubComponentTarget &&
          showMode === hmi.constant.showMode.design
        ) {
          var eventX = d3.event.x;
          var eventY = d3.event.y;
          var component = null;
          var componentIndex = allData.findIndex(function (element) {
            return element.components[subComponent.alias].id === selectTargetId;
          });
          if (componentIndex !== -1) {
            component = allData[componentIndex];
            component.components[subComponent.alias].x = eventX;
            component.components[subComponent.alias].y = eventY;
            transformAliasPosition(
              component.components[subComponent.alias].id,
              component,
              component.components[subComponent.alias]
            );
          }
        }
      })
      .on("dragend", function (d, i) {
        if (
          dragSubComponentTarget &&
          showMode === hmi.constant.showMode.design
        ) {
          unSelectComponent();
        }
      });
    //value
    dragValueBehavior = d3.behavior
      .drag()
      .on("dragstart", function (d, i) {
        d3.event.sourceEvent.stopPropagation();
        if (
          dragSubComponentTarget &&
          showMode === hmi.constant.showMode.design
        ) {
          dragSubComponentTarget.attr("pointer-events", "none");
        }
      })
      .on("drag", function (d, i) {
        if (
          dragSubComponentTarget &&
          showMode === hmi.constant.showMode.design
        ) {
          var eventX = d3.event.x;
          var eventY = d3.event.y;
          var component = null;
          var componentIndex = allData.findIndex(function (element) {
            return element.components[subComponent.value].id === selectTargetId;
          });
          if (componentIndex !== -1) {
            component = allData[componentIndex];
            component.components[subComponent.value].x = eventX;
            component.components[subComponent.value].y = eventY;
            transformValuePosition(
              component.components[subComponent.value].id,
              component,
              component.components[subComponent.value]
            );
          }
        }
      })
      .on("dragend", function (d, i) {
        if (
          dragSubComponentTarget &&
          showMode === hmi.constant.showMode.design
        ) {
          unSelectComponent();
        }
      });
  };

  var addSubComponents = function (d, data) {
    d.components.push(addMainComponent(d, data));
    d.components.push(addAliasComponent(d, data));
    d.components.push(addValueComponent(d, data));
  };

  var addMainComponent = function (d, data) {
    var result = null;
    if (!data) {
      result = {
        id: d.id + "-sub-" + (subComponent.main + 1),
        key: d.id + "-sub-" + (subComponent.main + 1),
        index: subComponent.main,
        width: defaultWidth,
        height: defaultHeight,
        x: 0,
        y: 0
      };
    } else {
      result = {
        id: data.components[subComponent.main].id,
        key: data.components[subComponent.main].key,
        index: data.components[subComponent.main].index,
        width: data.components[subComponent.main].width,
        height: data.components[subComponent.main].height,
        x: data.components[subComponent.main].x,
        y: data.components[subComponent.main].y
      };
    }

    return result;
  };

  var addAliasComponent = function (d, data) {
    var result = null;
    if (!data) {
      result = {
        id: d.id + "-sub-" + (subComponent.alias + 1),
        index: subComponent.alias,
        text: d.key,
        fill: "black",
        x: 0,
        y: -10,
        rx: 0,
        ry: 0
      };
    } else {
      result = {
        id: data.components[subComponent.alias].id,
        index: data.components[subComponent.alias].index,
        text: data.components[subComponent.alias].text,
        fill: data.components[subComponent.alias].fill,
        x: data.components[subComponent.alias].x,
        y: data.components[subComponent.alias].y,
        rx: data.components[subComponent.alias].rx,
        ry: data.components[subComponent.alias].ry
      };
    }

    return result;
  };

  var addValueComponent = function (d, data) {
    var result = null;
    if (!data) {
      result = {
        id: d.id + "-sub-" + (subComponent.value + 1),
        index: subComponent.value,
        text: "pressure-" + (allData.length + 1),
        fill: "black",
        x: 0,
        y:
          d.height +
          pipe.getDefaultHeight(d.config) +
          hmi.utils.fontSize(d.config.valueFont.size),
        rx: 0,
        ry: 0
      };
    } else {
      result = {
        id: data.components[subComponent.value].id,
        index: data.components[subComponent.value].index,
        text: data.components[subComponent.value].text,
        fill: data.components[subComponent.value].fill,
        x: data.components[subComponent.value].x,
        y: data.components[subComponent.value].y,
        rx: data.components[subComponent.value].rx,
        ry: data.components[subComponent.value].ry
      };
    }

    return result;
  };

  var selectComponent = function () {
    d3.select(dragTarget).style("stroke", color.select);
  };

  var selectSubComponent = function () {
    dragSubComponentTarget.style("stroke", color.select);
  };

  var unSelectComponent = function () {
    if (dragTarget) {
      d3.select(dragTarget).attr("pointer-events", "all").style("stroke", null);
      dragTarget = null;
      selectTargetId = null;
    }
    if (dragSubComponentTarget) {
      dragSubComponentTarget
        .attr("pointer-events", "all")
        .style("stroke", null);
      dragSubComponentTarget = null;
      selectTargetId = null;
    }
    resize_component.clean();
    connection_box.clean();
  };

  var updateComponentPosition = function (d) {
    d.components[subComponent.main].x = d.x;
    d.components[subComponent.main].y = d.y;
    allData[d.index] = d;
  };

  var transformComponentPosition = function (componentTarget, component) {
    var parentTargetId = d3.select(componentTarget).attr("parent");
    d3.select(componentTarget).attr("transform", function (d) {
      return "translate(" + 0 + "," + 0 + ")";
    });
    d3.select(componentTarget)
      .attr("transform", function (d) {
        return "translate(" + component.x + "," + component.y + ")";
      })
      .attr("x", function (d) {
        return component.x;
      })
      .attr("y", function (d) {
        return component.y;
      });
    var aliasId = parentTargetId + "-sub-" + (subComponent.alias + 1);
    transformAliasPosition(aliasId, component);
    var valueId = parentTargetId + "-sub-" + (subComponent.value + 1);
    transformValuePosition(valueId, component);
  };

  var transformAliasPosition = function (
    componentTargetId,
    component,
    aliasComponent
  ) {
    var textId = componentTargetId;
    d3.select("text#" + textId)
      .attr("x", function (d) {
        var rx = d.components[subComponent.alias].rx;
        d.components[subComponent.alias].rx = aliasComponent
          ? aliasComponent.x - component.x
          : rx;
        return rx ? component.x + rx : component.x + defaultAliasX;
      })
      .attr("y", function (d) {
        var ry = d.components[subComponent.alias].ry;
        d.components[subComponent.alias].ry = aliasComponent
          ? aliasComponent.y - component.y
          : ry;
        return ry ? component.y + ry : component.y + defaultAliasY;
      });
  };

  var transformValuePosition = function (
    componentTargetId,
    component,
    valueComponent
  ) {
    var textId = componentTargetId;
    switch (showMode) {
      case hmi.constant.showMode.design:
        d3.select("text#" + textId)
          .attr("x", function (d) {
            var rx = d.components[subComponent.value].rx;
            d.components[subComponent.value].rx = valueComponent
              ? valueComponent.x - component.x
              : rx;
            return rx ? component.x + rx : component.x + defaultValueX;
          })
          .attr("y", function (d) {
            var ry = d.components[subComponent.value].ry;
            d.components[subComponent.value].ry = valueComponent
              ? valueComponent.y - component.y
              : ry;
            return ry ? component.y + ry : component.y + defaultValueY;
          });
        break;
      case hmi.constant.showMode.monitor:
        d3.select("text#" + textId)
          .attr("x", function (d) {
            var rx = d.components[subComponent.value].rx;
            d.components[subComponent.value].rx = valueComponent
              ? valueComponent.x - component.x
              : rx;
            return rx ? component.x + rx : component.x + defaultValueX;
          })
          .attr("y", function (d) {
            var ry = d.components[subComponent.value].ry;
            d.components[subComponent.value].ry = valueComponent
              ? valueComponent.y - component.y
              : ry;
            return ry ? component.y + ry : component.y + defaultValueY;
          });
        break;
    }
  };

  var transformComponentValue = function (d) {
    d3.select("g#" + d.id)
      .select(".start")
      .text(function () {
        return 0;
      });
    d3.select("g#" + d.id)
      .select(".minMin")
      .text(function () {
        return d.config.minMinValue;
      });
    d3.select("g#" + d.id)
      .select(".min")
      .text(function () {
        return d.config.minValue;
      });
    d3.select("g#" + d.id)
      .select(".midle")
      .text(function () {
        return (d.config.maxMaxValue + d.config.minMinValue) / 2;
      });
    d3.select("g#" + d.id)
      .select(".max")
      .text(function () {
        return d.config.maxValue;
      });
    d3.select("g#" + d.id)
      .select(".maxMax")
      .text(function () {
        return d.config.maxMaxValue;
      });
    d3.select("g#" + d.id)
      .select(".end")
      .text(function () {
        return d.maxMaxValue + d.minMinValue;
      });

    if (!d.data.alarmColor) {
      d3.select("text#" + d.components[subComponent.alias].id).style(
        "fill",
        color.normal
      );
      d3.select("text#" + d.components[subComponent.value].id).style(
        "fill",
        color.normal
      );
      d3.select("g#" + d.id)
        .select(".PRESSUREVALVE_background")
        .attr("fill", "none");
    } else {
      d3.select("text#" + d.components[subComponent.alias].id).style(
        "fill",
        d.data.alarmColor
      );
      d3.select("text#" + d.components[subComponent.value].id).style(
        "fill",
        d.data.alarmColor
      );
      if (!d.data.alarmColor2) {
        d.data.isBlink = false;
        d3.select("g#" + d.id)
          .select(".PRESSUREVALVE_background")
          .attr("fill", function () {
            return d.data.alarmColor;
          })
          .style("opacity", 0.5);
      } else {
        d.data.isBlink = true;
        blink(d.id);
      }
    }
    var value = getValueByScales(d);
    d3.select("g#" + d.id)
      .select(".needle-1")
      .attr("transform", function () {
        return "rotate(" + value + ",75,65)";
      });
    d3.select("g#" + d.id)
      .select(".needle-2")
      .attr("transform", function () {
        return "rotate(" + value + ",75,65)";
      });
  };

  var blink = function (id) {
    var d = d3.select("g#" + id).data()[0];
    if (!d) {
      return;
    }
    var isBlink = d3.select("g#" + d.id).data()[0].data.isBlink;
    if (isBlink) {
      d3.select("g#" + d.id)
        .select(".PRESSUREVALVE_background")
        .transition()
        .duration(100)
        .attr("fill", function () {
          return d.data.alarmColor;
        })
        .style("opacity", 0.5)
        .transition()
        .duration(100)
        .attr("fill", function () {
          return d.data.alarmColor2;
        })
        .style("opacity", 0.5)
        .each("end", function (d) {
          blink(d.id);
        });
    } else {
      if (d.data.alarmColor) {
        d3.select("g#" + d.id)
          .select(".PRESSUREVALVE_background")
          .attr("fill", function () {
            return d.data.alarmColor;
          });
      } else {
        d3.select("g#" + d.id)
          .select(".PRESSUREVALVE_background")
          .attr("fill", "none")
          .style("opacity", 1);
      }

      return;
    }
  };

  var initializeCanvasObjects = function (gComponent, gEnter) {
    //add main component
    var path = gComponent
      .append("g")
      .classed("component-ele", true)
      .attr("id", function (d) {
        return d.components[subComponent.main].id;
      })
      .attr("parent", function (d) {
        return d.id;
      })
      .html(svgNode)

      .attr("x", function (d) {
        return d.components[subComponent.main].x;
      })
      .attr("y", function (d) {
        return d.components[subComponent.main].y;
      });

    //main component click diferents behaviours per show mode
    path.on("click", function (event) {
      d3.event.stopPropagation();
      hmi.utils.unSelectComponent();
      event.select = true;
      resize_component.data(event).selector(this);
      selectTargetId = d3.select(this).attr("parent");
      switch (showMode) {
        // click in design mode
        case hmi.constant.showMode.design:
          dragTarget = this;
          selectComponent();
          dispatch.selectElement({
            component: selectTargetId,
            signal: signal,
            has_pipe: true
          });
          dispatch.selectText(undefined);
          break;
        case hmi.constant.showMode.match:
          if (event.stopPropagation) {
            event.stopPropagation();
          }
          dispatch.selectElement({
            component: selectTargetId,
            signal: signal,
            has_pipe: true
          });
          dragTarget = this;
          selectComponent();

          break;
      }
    });

    path.on({
      mouseover: function (d) {
        d3.select(this).style("cursor", d.select ? "move" : "pointer");
        connection_box
          .selector(this)
          .data(d)
          .hidden(pendingPipe ? false : true);
      },
      mouseout: function (d) {
        d3.select(this).style("cursor", "default");
      }
    });

    var textAlias = gComponent
      .append("text")
      .attr("class", "preasure-text-alias")
      .attr("id", function (d) {
        return d.components[subComponent.alias].id;
      })
      .attr("parent", function (d) {
        return d.id;
      })
      .style("fill", function (d) {
        return d.components[subComponent.alias].fill;
      });

    textAlias.on("click", function (event) {
      d3.event.stopPropagation();
      hmi.utils.unSelectComponent();

      selectTargetId = d3.select(this).attr("id");
      dragSubComponentTarget = d3.select(this);
      switch (showMode) {
        case hmi.constant.showMode.design:
          selectSubComponent();
          dispatch.selectText({
            key: event.key,
            sub_key: selectTargetId,
            aliasFont: event.config.aliasFont
          });
          break;
      }
    });
    textAlias.on({
      mouseover: function (d) {
        d3.select(this).style("cursor", "pointer");
      },
      mouseout: function (d) {
        d3.select(this).style("cursor", "default");
      }
    });
    textAlias.call(dragAliasBehavior);

    gEnter
      .select("text.preasure-text-alias")
      .attr("x", function (d) {
        return d.components[subComponent.alias].x;
      })
      .attr("y", function (d) {
        return d.components[subComponent.alias].y;
      })
      .style("font", function (d) {
        return hmi.utils.generateFont(d.config.aliasFont);
      })
      .text(function (d) {
        var text = "";
        if (
          showMode === hmi.constant.showMode.monitor ||
          (showMode === hmi.constant.showMode.match && d.alias)
        ) {
          text = d.alias;
        } else {
          text = d.components[subComponent.alias].text;
        }
        return text;
      });

    gEnter.select("#warningleft").attr("visibility", function (d) {
      return d.config.minValue && d.config.minMinValue
        ? "visibility"
        : "hidden";
    });
    gEnter.select("#alarmleft").attr("visibility", function (d) {
      return d.config.minValue || d.config.minMinValue
        ? "visibility"
        : "hidden";
    });

    gEnter.select("#alarmleft").attr("fill", function (d) {
      if (d.config.minMinValue) {
        return colorError;
      }
      return colorWarning;
    });

    gEnter.select("#warningright").attr("visibility", function (d) {
      return d.config.maxValue && d.config.maxMaxValue
        ? "visibility"
        : "hidden";
    });
    gEnter.select("#alarmright").attr("visibility", function (d) {
      return d.config.maxValue || d.config.maxMaxValue
        ? "visibility"
        : "hidden";
    });

    gEnter.select("#alarmright").attr("fill", function (d) {
      if (d.config.maxMaxValue) {
        return colorError;
      }
      return colorWarning;
    });

    switch (showMode) {
      case hmi.constant.showMode.monitor:
      case hmi.constant.showMode.design:
        var textValue = gComponent
          .append("text")
          .attr("class", "preasure-text-value")
          .attr("id", function (d) {
            return d.components[subComponent.value].id;
          })
          .attr("parent", function (d) {
            return d.id;
          })
          .style("fill", function (d) {
            return d.components[subComponent.value].fill;
          });
        textValue.on("click", function (event, d) {
          d3.event.stopPropagation();
          hmi.utils.unSelectComponent();
          selectTargetId = d3.select(this).attr("id");
          dragSubComponentTarget = d3.select(this);
          switch (showMode) {
            case hmi.constant.showMode.design:
              selectSubComponent();
              dispatch.selectText({
                key: event.key,
                sub_key: selectTargetId,
                valueFont: event.config.valueFont
              });
              break;
          }
        });
        textValue.on({
          mouseover: function (d) {
            d3.select(this).style("cursor", "pointer");
          },
          mouseout: function (d) {
            d3.select(this).style("cursor", "default");
          }
        });
        textValue.call(dragValueBehavior);
        gEnter
          .select("text.preasure-text-value")
          .attr("x", function (d) {
            return d.components[subComponent.value].x;
          })
          .attr("y", function (d) {
            return d.components[subComponent.value].y;
          })
          .style("font", function (d) {
            return hmi.utils.generateFont(d.config.valueFont);
          })
          .text(function (d) {
            transformComponentValue(d);
            var unitMeasure = "";
            if (d.config && d.config.unitMeasure) {
              unitMeasure = d.config.unitMeasure;
            }
            return hmi.utils.generateValueFormat(
              d.data.value,
              d.config.valueFont.valueFormat,
              unitMeasure
            );
          });
        break;
    }
  };

  function pressure(selection) {
    selection.each(function (data) {
      allData = data;
      var container = d3.select(this).data(data);
      svgNode = hmi.symbols.pressure;
      pressure.container = this;
      if (!isInitialize) {
        initialize();
      }

      container
        .selectAll("g.nv-group-pressure")
        .data([data])
        .enter()
        .append("g")
        .attr("class", "nv-group-pressure");

      var gEnter = d3
        .select("g.nv-group-pressure")
        .selectAll("g.nv-pressure")
        .data(data, function (item) {
          return item.key;
        });
      var gComponent = gEnter
        .enter()
        .append("g")
        .attr("class", "nv-pressure")
        .attr("id", function (d) {
          var t = zoomTrans;

          if (d.components[subComponent.main].x === 0) {
            updateComponentPosition(d);
          }
          var scales = generateScales(d);

          normalScales.push(scales.normalScale);
          minAlarmScales.push(scales.minAlarmScale);
          minWarningScales.push(scales.minWarningScale);
          maxWarningScales.push(scales.maxWarningScale);
          maxAlarmScales.push(scales.maxAlarmScale);

          return d.id;
        })
        .call(hmi.dragBehavior.dragComponent);

      gEnter
        .attr("x", function (d) {
          return d.x;
        })
        .attr("y", function (d) {
          return d.y;
        })
        .attr("transform", function (d) {
          return (
            "translate(" +
            d.components[subComponent.main].x +
            "," +
            d.components[subComponent.main].y +
            ")"
          );
        });

      initializeCanvasObjects(gComponent, gEnter);
      action_component(gEnter, gComponent);
      connections(gEnter, gComponent);

      gEnter
        .select("g.component-ele > svg")
        .attr("width", function (d) {
          return d.width;
        })
        .attr("height", function (d) {
          return d.height;
        });
      gEnter.exit().remove();
      pressure.update = function () {
        container.datum(allData).call(pressure);
      };
    });
    return pressure;
  }

  function resizeDragCallback(d) {
    d.components[subComponent.main].x = d.x;
    d.components[subComponent.main].y = d.y;
    d.components[subComponent.main].width = d.width;
    d.components[subComponent.main].height = d.height;
    d.components[subComponent.value].y = d.height + 35;
    pressure.update();
  }

  function getValueByScales(d) {
    var value =
      d.data.value > d.config.maxScale
        ? d.config.maxScale
        : d.data.value < d.config.minScale
        ? d.config.minScale
        : d.data.value;
    if (d.config.minValue && d.config.minMinValue) {
      if (value >= d.config.minScale && value < d.config.minMinValue) {
        return minAlarmScales[d.index](value);
      }
      if (value >= d.config.minMinValue && value < d.config.minValue) {
        return minWarningScales[d.index](value);
      }
    } else if (d.config.minValue && value <= d.config.minValue) {
      return minAlarmScales[d.index](value);
    } else if (d.config.minMinValue && value <= d.config.minMinValue) {
      return minAlarmScales[d.index](value);
    }
    if (d.config.maxValue && d.config.maxMaxValue) {
      if (value >= d.config.maxMaxValue && value <= d.config.maxScale) {
        return maxAlarmScales[d.index](value);
      }
      if (value >= d.config.maxValue && value < d.config.maxMaxValue) {
        return maxWarningScales[d.index](value);
      }
    } else if (d.config.maxValue && value >= d.config.maxValue) {
      return maxAlarmScales[d.index](value);
    } else if (d.config.maxMaxValue && value >= d.config.maxMaxValue) {
      return maxAlarmScales[d.index](value);
    }

    return normalScales[d.index](value);
  }

  function generateScales(d) {
    var normalScale = d3.scale.linear();
    var minAlarmScale = d3.scale.linear();
    var minWarningScale = d3.scale.linear();
    var maxWarningScale = d3.scale.linear();
    var maxAlarmScale = d3.scale.linear();

    var minScale = d.config.minMinValue
      ? d.config.minMinValue
      : d.config.minValue;
    minAlarmScale.domain([d.config.minScale, minScale]).range([-167, -125]);

    minWarningScale
      .domain([d.config.minMinValue, d.config.minValue])
      .range([-125, -85]);

    maxWarningScale
      .domain([d.config.maxValue, d.config.maxMaxValue])
      .range([10, 50]);

    var maxScale = d.config.maxMaxValue
      ? d.config.maxMaxValue
      : d.config.maxValue;
    maxAlarmScale.domain([maxScale, d.config.maxScale]).range([50, 92]);

    var minValue = d.config.minValue
      ? d.config.minMinValue
        ? [d.config.minValue, -85]
        : [d.config.minValue, -125]
      : d.config.minMinValue
      ? [d.config.minMinValue, -125]
      : [d.config.minScale, -167];
    var maxValue = d.config.maxValue
      ? d.config.maxMaxValue
        ? [d.config.maxValue, 10]
        : [d.config.maxValue, 50]
      : d.config.maxMaxValue
      ? [d.config.maxMaxValue, 50]
      : [d.config.maxScale, 92];

    normalScale
      .domain([minValue[0], maxValue[0]])
      .range([minValue[1], maxValue[1]]);
    return {
      normalScale: normalScale,
      minAlarmScale: minAlarmScale,
      minWarningScale: minWarningScale,
      maxWarningScale: maxWarningScale,
      maxAlarmScale: maxAlarmScale
    };
  }

  pressure.dispatch = dispatch;

  pressure.options = hmi.utils.optionsFunc.bind(pressure);

  pressure._calls = new (function () {
    this.getObject = function (data) {
      var idNumber = 1;
      var temp = allData[allData.length - 1];
      if (temp) {
        idNumber = parseInt(temp.id.match(/\d+/g)[0]) + 1;
      }
      // result = temp.id.match(/\d+/g);
      var result = null;
      if (!data) {
        result = {
          id: "pressure-" + idNumber,
          key: "pressure-" + idNumber,
          alias: "pressure-" + idNumber,
          index: allData.length,
          groupType: groupType,
          type: type,
          width: defaultWidth,
          height: defaultHeight,
          alignment: hmi.constant.alignment.horizontal,
          x: 0,
          y: 0,
          config: {
            minScale: 0,
            maxScale: 60,
            minValue: 20,
            minMinValue: 10,
            maxValue: 40,
            maxMaxValue: 50,
            unitMeasure: "",
            pipeColor: "none",
            aliasFont: {
              weight: "bold",
              size: "15px",
              family: "sans-serif"
            },
            valueFont: {
              weight: "bold",
              size: "15px",
              family: "sans-serif",
              valueFormat: "+,.3f"
            }
          },
          components: [],
          data: {
            value: 30
          }
        };
        addSubComponents(result, null);
      } else {
        result = {
          id: data.id,
          key: data.key,
          index: data.index,
          groupType: groupType,
          type: data.type,
          width: data.width,
          height: data.height,
          x: data.x,
          y: data.y,
          alignment: data.alignment,
          config: data.config,
          components: [],
          data: {
            value: 0
          }
        };
        addSubComponents(result, data);
      }

      return result;
    };
    this.updateConfig = function (data) {
      var item = allData.find(function (item) {
        return item.key === data.key;
      });

      if (item) {
        item.alias = data.alias;
        item.config.minScale = data.config.minScale
          ? data.config.minScale
          : item.config.minScale;
        item.config.maxScale = data.config.maxScale
          ? data.config.maxScale
          : item.config.maxScale;
        item.config.minValue = data.config.minValue
          ? data.config.minValue
          : undefined;
        item.config.minMinValue = data.config.minMinValue
          ? data.config.minMinValue
          : undefined;
        item.config.maxValue = data.config.maxValue
          ? data.config.maxValue
          : undefined;
        item.config.maxMaxValue = data.config.maxMaxValue
          ? data.config.maxMaxValue
          : undefined;
        item.config.unitMeasure = data.config.unitMeasure
          ? data.config.unitMeasure
          : item.config.unitMeasure;
        item.config.aliasFont = data.config.aliasFont
          ? data.config.aliasFont
          : item.config.aliasFont;
        item.config.valueFont = data.config.valueFont
          ? data.config.valueFont
          : item.config.valueFont;
        item.config.pipeColor = data.config.pipeColor
          ? data.config.pipeColor
          : item.config.pipeColor;
        item.config.actions = data.config.actions;

        if (showMode === hmi.constant.showMode.design) {
          item.components[subComponent.value].x = 0;
          item.components[subComponent.value].y =
            item.height +
            pipe.getDefaultHeight(item.config) +
            hmi.utils.fontSize(item.config.valueFont.size);
        }
        //update scales
        var scales = generateScales(item);

        normalScales[item.index] = scales.normalScale;
        minAlarmScales[item.index] = scales.minAlarmScale;
        minWarningScales[item.index] = scales.minWarningScale;
        maxWarningScales[item.index] = scales.maxWarningScale;
        maxAlarmScales[item.index] = scales.maxAlarmScale;
      }
      return item;
    };

    this.calcXYPass = function (d, xSteps, ySteps) {
      var x = xSteps(d.x);
      var y = ySteps(d.y);
      return [x, y];
    };

    this.unSelectComponent = unSelectComponent;
    this.updateComponentPosition = updateComponentPosition;
    this.transformComponentPosition = transformComponentPosition;
  })();

  connection_box.dispatch.on("conectionClick", function (event) {
    switch (showMode) {
      // click in design mode
      case hmi.constant.showMode.design:
        if (pendingPipe) {
          pipe.Change(event);
        }

        break;
    }
  });

  resize_component.dispatch.on("finish_resize", function (event) {
    switch (showMode) {
      // click in design mode
      case hmi.constant.showMode.design:
        pipe.updateChangeLink(event);
        break;
    }
  });

  pressure._options = Object.create(
    {},
    {
      // simple options, just get/set the necessary values
      showMode: {
        get: function () {
          return showMode;
        },
        set: function (_) {
          showMode = _;
        }
      },
      availableWidth: {
        get: function () {
          return availableWidth;
        },
        set: function (_) {
          availableWidth = _;
        }
      },
      availableHeight: {
        get: function () {
          return availableHeight;
        },
        set: function (_) {
          availableHeight = _;
        }
      },
      zoomTrans: {
        get: function () {
          return zoomTrans;
        },
        set: function (_) {
          zoomTrans = _;

          var xSteps = hmi.utils.StepsComponents(
            availableWidth,
            1.5 * defaultWidth,
            zoomTrans.scale
          );
          var ySteps = hmi.utils.StepsComponents(
            availableHeight,
            1.5 * defaultHeight,
            zoomTrans.scale
          );
          xScale.domain(xSteps[0]).range(xSteps[1]);
          yScale.domain(ySteps[0]).range(ySteps[1]);
        }
      },
      pipe: {
        get: function () {
          return pipe;
        },
        set: function (_) {
          // _.dispatch.on('pendingPipeChange', function (d) {
          //     pendingPipe = !d.pipe ? false : true;
          // });
          pipe = _;
        }
      },
      pendingPipe: {
        get: function () {
          return pendingPipe;
        },
        set: function (_) {
          pendingPipe = !_.pipe ? false : true;
        }
      },
      action_execute: {
        get: function () {
          return action_component;
        }
      }
    }
  );

  hmi.utils.initOptions(pressure);

  return pressure;
};
